import api from './axiosConfig';
import { PRODUCT_GLOBAL_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';

export const fetchProductsGlobal = async () => {

    try {
        const response = await api.get(PRODUCT_GLOBAL_ENDPOINT());
        return response.data
    } catch (error) {
        console.error("Error fetching hero data", error);

        await logError('product_global_fetch', error, {
            endpoint: PRODUCT_GLOBAL_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};
